import { render, staticRenderFns } from "./CustomModal.vue?vue&type=template&id=9a816746&scoped=true"
import script from "./CustomModal.vue?vue&type=script&lang=js"
export * from "./CustomModal.vue?vue&type=script&lang=js"
import style0 from "./CustomModal.vue?vue&type=style&index=0&id=9a816746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a816746",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardActions,VCardText,VDialog})
